import React, { PureComponent } from 'react';
import {
  getProductType,
  getShortName,
  getTeamGuid,
} from '../../selectors/apiSelectors';

import { IAppState } from '../../types/state.d';
import { ROUTES } from '../../consts';
import Tab from './Tab';
import { appThunk } from '../../actions/thunks';
import config from '../../config';
import { connect } from 'react-redux';
import { generatePath } from 'react-router';
import ProductName from '../../consts/productType';

export type TabType = 'view' | 'settings' | 'edit' | 'members';

type MapStateToProps = {
  shortName: string;
  teamGuid: string;
  productType: string;
};

type MapDispatchToProps = {
  pushToPage: typeof appThunk.pushToPage;
};

export type Props = MapStateToProps &
  MapDispatchToProps & {
    active: TabType;
  };

export class AdminTabs extends PureComponent<Props> {
  handleEditClick = () => {
    const { teamGuid } = this.props;
    this.props.pushToPage(
      generatePath(ROUTES.EDIT_TEAM, { pageType: 'manage', teamGuid }),
    );
  };

  handleMembersClick = () => {
    const { teamGuid } = this.props;
    this.props.pushToPage(
      generatePath(ROUTES.EDIT_MEMBERS, { pageType: 'manage', teamGuid }),
    );
  };

  handleSettingsClick = () => {
    const { teamGuid } = this.props;
    this.props.pushToPage(
      generatePath(ROUTES.SETTINGS, { pageType: 'manage', teamGuid }),
    );
  };

  render() {
    const { active, shortName, productType } = this.props;
    const viewUrl =
      productType === ProductName.InMemoryTeam
        ? `${config.baseFrpUri}/remember/${shortName}`
        : `${config.basePageUri}${shortName}`;

    return (
      <nav className="jg-tc-admin-tabs jg-background--white">
        <ul className="jg-list--inline jg-space-phxs jg-space-phsm@md container">
          <Tab isActive={active === 'view'} type="view" link={viewUrl} />
          <Tab
            isActive={active === 'edit'}
            type="edit"
            onClick={this.handleEditClick}
          />
          <Tab
            isActive={active === 'settings'}
            type="settings"
            onClick={this.handleSettingsClick}
          />
          <Tab
            isActive={active === 'members'}
            type="members"
            onClick={this.handleMembersClick}
          />
        </ul>
      </nav>
    );
  }
}

export const mapStateToProps = (state: IAppState): MapStateToProps => ({
  shortName: getShortName(state),
  teamGuid: getTeamGuid(state) || '',
  productType: getProductType(state) || '',
});

export const mapDispatchToProps: MapDispatchToProps = {
  pushToPage: appThunk.pushToPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminTabs);
